import { DataSyncStrategyProvider } from '../pages/DataSync/DataSyncStrategyProvider';
import { useCallback } from 'react';
import { DataSyncViewModel } from '../types/DataSyncViewModel';

export function useGetStrategy(dataSync: DataSyncViewModel) {
  return useCallback(() => DataSyncStrategyProvider.getStrategy(dataSync), [dataSync]);
}
